import { type LinkedinBasicCredentials } from '@unipile/provider-linkedin';
import { Button, Field, FieldGroup, FieldLabel, Input, LocationConfig, Spinner, useHostedAuthSession } from '@unipile/ui';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function CredentialsForm({
  onSubmit,
  isPending,
}: {
  onSubmit: (data: LinkedinBasicCredentials) => void;
  isPending: boolean;
}) {
  const { data: session } = useHostedAuthSession();

  const form = useForm<LinkedinBasicCredentials>({
    defaultValues: {
      username: session?.config?.global?.login_hint || '',
      password: '',
    },
  });

  const { t } = useTranslation();

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className="mt-8 space-y-4">
      <FieldGroup>
        <Controller
          control={form.control}
          name="username"
          rules={{ required: t('LoginScreen.form.username.required', { ns: 'linkedin' }) }}
          render={({ field }) => (
            <Field>
              <FieldLabel>{t('LoginScreen.form.username.label', { ns: 'linkedin' })}</FieldLabel>
              <Input placeholder={t('LoginScreen.form.username.label', { ns: 'linkedin' })} {...field} />
            </Field>
          )}
        />

        <Controller
          control={form.control}
          name="password"
          rules={{ required: t('LoginScreen.form.password.required', { ns: 'linkedin' }) }}
          render={({ field }) => (
            <Field>
              <FieldLabel>{t('LoginScreen.form.password.label', { ns: 'linkedin' })}</FieldLabel>
              <Input type="password" placeholder="••••••••" {...field} />
            </Field>
          )}
        />
        <LocationConfig provider="linkedin" />

        <Button disabled={isPending} type="submit">
          {isPending && <Spinner />}
          {t('Common.next')}
        </Button>
      </FieldGroup>
    </form>
  );
}
